
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.776","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 4","d":"M10.14 5.128L7.885 0 5.632 5.128l-5.633.6 4.24 3.682-1.228 5.588 4.874-2.94 4.874 2.94-1.227-5.588 4.241-3.682z","fill":"#224dc5"}})])
          )
        }
      }
    